// API wrappers for the settings, password, export, and account-deletion endpoints.

import { apiRequest } from "./client";
import { getToken } from "../auth/storage";
import { triggerDownload } from "../utils/download";

export interface UserSettings {
  notify_batch_complete: boolean;
  notify_batch_attach_excel: boolean;
  notify_low_balance: boolean;
  low_balance_threshold_cents: number;
  retention_days: number;
}

export function getSettings(): Promise<UserSettings> {
  return apiRequest<UserSettings>("/me/settings");
}

export function updateSettings(data: Partial<UserSettings>): Promise<UserSettings> {
  return apiRequest<UserSettings>("/me/settings", { method: "PUT", json: data });
}

export async function changePassword(current: string, newPass: string): Promise<void> {
  await apiRequest("/me/password", {
    method: "PUT",
    json: { current_password: current, new_password: newPass },
  });
}

// The export endpoint returns a binary ZIP, so we bypass apiRequest (which
// only handles JSON/text) and use raw fetch, then hand off to triggerDownload.
export async function exportMyData(): Promise<void> {
  const token = getToken();
  const response = await fetch("/api/me/export", {
    headers: {
      Accept: "application/zip",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!response.ok) {
    throw new Error(`Export failed with status ${response.status}`);
  }
  const blob = await response.blob();
  const contentDisposition = response.headers.get("content-disposition") ?? "";
  const match = /filename="?([^";\s]+)"?/.exec(contentDisposition);
  const filename = match?.[1] ?? "addbills-export.zip";
  triggerDownload(blob, filename);
}

export async function deleteAccount(confirmation: string): Promise<void> {
  await apiRequest("/me", { method: "DELETE", json: { confirmation } });
}

export async function updateLocale(locale: string): Promise<void> {
  await apiRequest("/me/locale", { method: "PUT", json: { locale } });
}
